"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleEditPayloadFactoryFromJS = exports.RuleEditPayloadFactory = void 0;
const BCRuleManager_1 = require("@bimser/components/dist/BCRuleManager");
const components_1 = require("@bimser/components");
const immutable_1 = require("immutable");
exports.RuleEditPayloadFactory = (0, immutable_1.Record)({
    windowId: null,
    rule: BCRuleManager_1.RuleEngineEntities.RuleFactory(),
    originalActionType: null,
    hideRulePanel: false,
    rules: (0, immutable_1.Map)(),
    fields: (0, immutable_1.List)(),
    controlEventList: (0, immutable_1.List)(),
    pluginId: null,
    sourceWindowId: null,
    autoClean: false
});
const RuleEditPayloadFactoryFromJS = function (data) {
    const rules = {};
    for (const key in data.rules) {
        const item = data.rules[key];
        rules[key] = BCRuleManager_1.RuleEngineEntities.RuleFactoryFromJS(item);
    }
    const fields = data.fields && data.fields.length
        ? data.fields.map(i => components_1.BCTreeSelectEntities.TreeDataFactoryFromJS(i))
        : [];
    const controlEventList = data.controlEventList && data.controlEventList.length
        ? data.controlEventList.map(i => components_1.BCTreeSelectEntities.TreeDataFactoryFromJS(i))
        : [];
    return (0, exports.RuleEditPayloadFactory)({
        windowId: data.windowId,
        rule: data.rule ? BCRuleManager_1.RuleEngineEntities.RuleFactoryFromJS(data.rule) : null,
        originalActionType: data.originalActionType,
        hideRulePanel: data.hideRulePanel,
        rules: (0, immutable_1.Map)(rules),
        fields: (0, immutable_1.List)(fields),
        controlEventList: (0, immutable_1.List)(controlEventList),
        pluginId: data.pluginId,
        sourceWindowId: data.sourceWindowId,
        autoClean: data.autoClean
    });
};
exports.RuleEditPayloadFactoryFromJS = RuleEditPayloadFactoryFromJS;
//# sourceMappingURL=IRuleEditPayload.js.map